export enum DocumentType {
    PATENT_DRAFT = 'patent_draft',
    DISCLOSURE = 'disclosure',
    PATENT_CLAIM = 'patent_claim',
    SPECIFICATION = 'specification',
    PROSECUTION = 'prosecution',
    TECHNICAL_DOC = 'technical_doc',
    OTHER = 'other'
}

export enum WorkMode {
    AGENT = 'agent',
    COPILOT = 'copilot'
}

export enum PatentRegion {
    US = 'US',
    CN = 'CN',
    EP = 'EP',
    JP = 'JP',
    KR = 'KR',
    WIPO = 'WIPO'
}

export enum StyleCategory {
    SYSTEM = 'system',
    USER = 'user',
    ALL = 'all'
}

export enum StyleSourceType {
    MANUAL = 'manual',
    REFERENCE = 'reference'
}

export enum AgentType {
    DISCLOSURE = 'disclosure',
    PATENT_DRAFT = 'patent_draft',
    PROSECUTION = 'prosecution',
    PATENT_REVIEW = 'patent_review'
}

export enum AttachmentCategory {
    DISCLOSURE = 'Disclosure',
    APPLICATION = 'Application',
    PROSECUTION = 'Prosecution',
    OTHER = 'Other'
}
